import { render, staticRenderFns } from "./ImgFile.vue?vue&type=template&id=6e718c4b&scoped=true"
import script from "./ImgFile.vue?vue&type=script&lang=js"
export * from "./ImgFile.vue?vue&type=script&lang=js"
import style0 from "./ImgFile.vue?vue&type=style&index=0&id=6e718c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e718c4b",
  null
  
)

export default component.exports